import fileDownload from 'js-file-download'

export default {
  actions: {
    transactions({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('queryPost', {
          url: 'transactions',
          data,
        })
          .then((response) => {
            if (response.data == null) {
              reject(100)
            } else {
              resolve(response.data)
            }
          })
          .catch(() => {
            reject(100)
          })
      })
    },
    downloadTransactions({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('queryPost', {
          url: '/transactions/excel',

          // data: {
          //   types: data.types,
          //   page: data.page,
          // },
          params: { responseType: 'blob' },
        })
          .then((response) => {
            if (response.data == null) {
              reject(100)
            } else {
              fileDownload(response.data, 'Финансы.xlsx')
              resolve()
            }
          })
          .catch(() => {
            reject(100)
          })
      })
    },
  },
  mutations: {},
  state: {},
  getters: {},
}
